import { Box, Grid, Stack, TextField, Typography, Divider } from "@mui/material";
import CampoMoeda from "./CampoMoeda";

const moeda = (v) => Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
const ehOutros = (t) => /outro|outra/i.test(t.Codigo || "");

// Lista FIXA de categorias (despesas + receitas), cada uma com campo de valor —
// como no formulário antigo. O usuário preenche o que se aplica.
export default function LancamentosFixos({ tiposR, tiposD, valores, setValores }) {
  const setV = (id, campo, v) =>
    setValores((prev) => ({ ...prev, [id]: { ...prev[id], [campo]: v } }));
  const total = (tipos) => tipos.reduce((s, t) => s + (Number(valores[t.Id]?.Valor) || 0), 0);

  // Função que RETORNA JSX (não é um componente) — evita remontar os campos a cada
  // tecla, o que faria o input perder o foco.
  const renderSecao = (titulo, tipos) => (
    <Box sx={{ mb: 2 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
        <Typography variant="subtitle2" color="primary">{titulo}</Typography>
        <Typography variant="body2" color="text.secondary">Total: <b>{moeda(total(tipos))}</b></Typography>
      </Stack>
      <Grid container spacing={2}>
        {tipos.map((t) => (
          <Grid key={t.Id} size={{ xs: 12, sm: 6 }}>
            <Stack direction="row" spacing={1}>
              {ehOutros(t) && (
                <TextField label="Especificar" sx={{ flex: 1 }} value={valores[t.Id]?.Descricao || ""}
                  onChange={(e) => setV(t.Id, "Descricao", e.target.value)} />
              )}
              <CampoMoeda label={t.Descricao} fullWidth={!ehOutros(t)}
                sx={ehOutros(t) ? { width: 160 } : undefined}
                value={valores[t.Id]?.Valor}
                onChange={(n) => setV(t.Id, "Valor", n)} />
            </Stack>
          </Grid>
        ))}
      </Grid>
    </Box>
  );

  return (
    <>
      {renderSecao("Despesas do último mês", tiposD)}
      <Divider sx={{ my: 2 }} />
      {renderSecao("Receitas / renda do último mês", tiposR)}
    </>
  );
}

// Constrói as linhas FseLancamentoFinanceiro a partir do mapa de valores.
export function montarLancamentos(tiposR, tiposD, valores) {
  const linhas = [];
  [...tiposR, ...tiposD].forEach((t) => {
    const v = valores[t.Id];
    const valor = Number(v?.Valor) || 0;
    const desc = v?.Descricao || null;
    if (valor > 0 || desc) linhas.push({ IdTipoLancamento: t.Id, Natureza: t.Natureza, Valor: valor, Descricao: desc });
  });
  return linhas;
}

// Reconstrói o mapa de valores a partir das linhas salvas.
export function valoresDeLancamentos(lancamentos) {
  const m = {};
  (lancamentos || []).forEach((l) => {
    if (l.IdTipoLancamento) m[l.IdTipoLancamento] = { Valor: l.Valor, Descricao: l.Descricao };
  });
  return m;
}
